import React from "react";
import { openTreatmentStatusState } from "../../atoms/open_treatment";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { CirclePause } from "lucide-react";

import navigationState from '../../atoms/navigate_state.atom'
import { profileData } from "../../atoms/user.atom";
import { api_bd_nr } from "../../services/Api";

const TicketRunningStatus = () => {
    const [treatmentOpen, set_treatmentOpen] = useRecoilState(openTreatmentStatusState)
    const [navigation_state, set_navigation_state] = useRecoilState(navigationState)
    const user_profile = useRecoilValue(profileData)

    // console.log('treatmentOpen: ', treatmentOpen)

    const getUserTreatments = (_userId) => {
        api_bd_nr.get(`/tickets/get_treatments/${_userId}`).then(({ data }) => {
            if (data?.length > 0) {
                // set_tratativa_aberta(data)
                set_treatmentOpen(data)
            } else {
                set_treatmentOpen(false)
            }
            // console.log('getUserTreatments', data)
        }).catch((error) => {
            //console.log('getUserTreatments error:', error)
        })
    }


    const stop_treatment = () => {
        return new Promise(async (resolve, reject) => {
            const dados_fim = {
                id_usuario: user_profile.id,
                nivel: user_profile.nivel,
                nome: user_profile.nome,
                fim: Date.now()
            }

            await api_bd_nr.put(`/tickets/stop_treatment/${treatmentOpen[0].ticket._id}`, dados_fim).then(resp => {
                // console.log('/tickets/stop_treatment: ', resp.data)
                set_navigation_state({ page_content: 'ticket_detail', data: resp.data[0] })
                // set_situacao_chamado(resp.data[0].situacao)
                getUserTreatments(user_profile.id)
                resolve(resp.data)
            }).catch(e => {
                alert('Erro ao tentar finalizar a tratativa, tente novamente mais tarde')
                reject(e)
            })
        })
    }


    return (
        treatmentOpen?.length > 0 ? (
            <div className="flex relative flex-row items-center py-2 px-3 bg-intec-300 rounded-[20px]">
                <div>
                    <div className="flex flex-row relative bg-intec-500 rounded-full cursor-pointer"
                        onClick={async () => {
                            if(window.confirm('Deseja realmente pausar esta tratativa?\n\nVocê será redirecionado para o ticket que estava em tratativa para que possa adicionar uma interação.')){
                                await stop_treatment()
                            }
                        }}
                    >
                        <div className="m-[7px] w-[8px] h-[8px] bg-white" style={{ zIndex: 88 }}></div>
                        <div className="miniloader bg-intec-500 selec-none" style={{
                            position: 'absolute',
                            width: 24,
                            height: 24,
                            marginLeft: -1,
                            marginTop: -1,
                            zIndex: 86,
                            border: '3px solid #f3f3f3',
                            // borderRadius: '50%',
                            borderTop: '3px solid #3c5ca6',
                        }}></div>
                        {/* <CirclePause style={{ zIndex: 88 }} /> */}
                    </div>
                </div>
                {/* <span className="font-bold">{treatmentOpen.map(t => t?.ticket?.cod_id || '').join(', ')}</span> */}
                <span className="font-bold">{treatmentOpen[0].ticket?.cod_id || ''}</span>
            </div >
        ) : (
            <></>
        )
    );
};

export default TicketRunningStatus;
